module.exports = __webpack_public_path__ + "images/0528692e7541ff3755880b3408793969.svg";